import { OrderState, OrderType } from '@sg/graphql-schema';

import { type GroupOrderPostOrderQuery } from './GraphQL/GroupOrderPostOrder.generated';

// ─────────────────────────────────────────────────────────────────────────────

export function getTerminalGroupOrder(
  order: GroupOrderPostOrderQuery['order'] | undefined,
): TerminalGroupOrder | undefined {
  const hostDisplayName = order?.multipartyDetails?.displayName;
  const isTerminalOrder =
    order?.orderState === OrderState.Complete || order?.orderState === OrderState.Discarded;

  if (!order || !isTerminalOrder) return;

  return {
    id: order.id,
    hasCurrentUserItems: order.lineItems.some((lineItem) => lineItem.orderParticipant?.isMe),
    hostDisplayName,
    orderChannel: getOrderChannel(order),
    orderState: order.orderState,
  };
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

function getOrderChannel(order: GroupOrderPostOrderQuery['order']): OrderChannel {
  if (order.restaurant?.isOutpost) return 'outpost';
  if (order.orderType === OrderType.Delivery) return 'delivery';

  return 'pickup';
}

// ─── Types ───────────────────────────────────────────────────────────────────

type TerminalGroupOrder = {
  id: string;
  hasCurrentUserItems: boolean;
  hostDisplayName: string | undefined;
  orderChannel: OrderChannel;
  orderState: OrderState.Complete | OrderState.Discarded;
};

type OrderChannel = 'delivery' | 'outpost' | 'pickup';
